import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

import { Box, Paper, Tabs, Tab, Tooltip } from '@mui/material';
import { CargoAdmissionLayout, ReportHistory } from './components';
import { SPP } from '../../storePickupPackage.classes';

export const CargoAdmission = () => {
    const history = useHistory();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState<number>(0);

    const { t } = useTranslation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tabParam = params.get('tab');
        if (tabParam) {
            const tabNumber = Number.parseInt(tabParam, 10);
            if (!Number.isNaN(tabNumber) && tabNumber >= 0 && tabNumber <= 1) {
                setActiveTab(tabNumber);
            }
        }
    }, [location.search]);

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
        history.push(`${location.pathname}?tab=${newValue}`);
    };

    const tabs = [
        {
            key: 'admission',
            label: t('storePickupPackageAdmission.cargoAdmission'),
            tooltip: t('storePickupPackageAdmission.cargoAdmission'),
            disabled: false,
            className: `${SPP.admissionTab} ${SPP.admissionTabAdmission}`,
        },
        {
            key: 'report-history',
            label: t('storePickupPackageAdmission.reportHistory'),
            tooltip: t('storePickupPackageAdmission.reportHistory'),
            disabled: false,
            className: `${SPP.admissionTab} ${SPP.admissionTabReportHistory}`,
        },
    ];

    return (
        <Paper className={SPP.admission} sx={{ padding: '16px', marginTop: '16px' }}>
            <Tabs
                value={activeTab}
                onChange={handleTabChange}
                className={SPP.admissionTabs}
                sx={{
                    '& .MuiTab-root': {
                        padding: '8px',
                        minHeight: '40px',
                        '&:hover': {
                            backgroundColor: 'rgba(3, 169, 244, 0.7)',
                            color: '#ffffff !important',
                        },
                    },
                }}
            >
                {tabs.map((tab, index) => (
                    <Tab
                        key={tab.label}
                        className={tab.className}
                        data-tab-key={tab.key}
                        data-tab-index={index}
                        label={
                            <Tooltip title={tab.tooltip} arrow>
                                <span>{tab.label}</span>
                            </Tooltip>
                        }
                    />
                ))}
            </Tabs>
            <Box className={SPP.admissionTabBody} sx={{ mt: 2, p: 1 }}>
                {activeTab === 0 && <CargoAdmissionLayout />}
                {activeTab === 1 && <ReportHistory />}
            </Box>
        </Paper>
    );
};
